/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountConnectionDto,
  CompleteConnectionRequest,
  FinWebFormResponse,
  GetAccountConnectionsParams,
  GetInstitutionsParams,
  InitiateConnectionRequest,
  InitiateConnectionResponse,
  InstitutionDto,
  OpenBankingPaymentDto,
  PaymentRequest,
  PaymentResponse,
  PaymentSubmissionRequest,
  PaymentSubmissionResponse,
  UpdateAccountActiveFlagPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OpenBankingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags open-banking-controller
   * @name PrepareFinapiCreditTransfer
   * @request POST:/api/v1/open-banking/provider/finapi/payments
   */
  prepareFinapiCreditTransfer = (data: PaymentRequest, params: RequestParams = {}) =>
    this.http.request<PaymentResponse, any>({
      path: `/v1/open-banking/provider/finapi/payments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareFinapiCreditTransferPath = '/v1/open-banking/provider/finapi/payments'
  static prepareFinapiCreditTransferMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name SubmitFinapiCreditTransfer
   * @request POST:/api/v1/open-banking/provider/finapi/payments/submit
   */
  submitFinapiCreditTransfer = (data: PaymentSubmissionRequest, params: RequestParams = {}) =>
    this.http.request<PaymentSubmissionResponse, any>({
      path: `/v1/open-banking/provider/finapi/payments/submit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static submitFinapiCreditTransferPath = '/v1/open-banking/provider/finapi/payments/submit'
  static submitFinapiCreditTransferMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name InitiateConnection
   * @request POST:/api/v1/open-banking/connections/initiate
   */
  initiateConnection = (data: InitiateConnectionRequest, params: RequestParams = {}) =>
    this.http.request<InitiateConnectionResponse, any>({
      path: `/v1/open-banking/connections/initiate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateConnectionPath = '/v1/open-banking/connections/initiate'
  static initiateConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name CompleteConnection
   * @request POST:/api/v1/open-banking/connections/complete
   */
  completeConnection = (data: CompleteConnectionRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/connections/complete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static completeConnectionPath = '/v1/open-banking/connections/complete'
  static completeConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name UpdateAccountActiveFlag
   * @request PATCH:/api/v1/open-banking/bank-accounts/{accountId}/active
   */
  updateAccountActiveFlag = (
    accountId: string,
    data: UpdateAccountActiveFlagPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/bank-accounts/${accountId}/active`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateAccountActiveFlagPath = '/v1/open-banking/bank-accounts/${accountId}/active'
  static updateAccountActiveFlagMethod = 'PATCH'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetFinApiWebForm
   * @request GET:/api/v1/open-banking/providers/finapi/{webFormId}
   */
  getFinApiWebForm = (webFormId: number, params: RequestParams = {}) =>
    this.http.request<FinWebFormResponse, any>({
      path: `/v1/open-banking/providers/finapi/${webFormId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFinApiWebFormPath = '/v1/open-banking/providers/finapi/${webFormId}'
  static getFinApiWebFormMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name FindOpenBankingPayment
   * @request GET:/api/v1/open-banking/provider/finapi/payments/{paymentId}
   */
  findOpenBankingPayment = (paymentId: string, params: RequestParams = {}) =>
    this.http.request<OpenBankingPaymentDto, any>({
      path: `/v1/open-banking/provider/finapi/payments/${paymentId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findOpenBankingPaymentPath = '/v1/open-banking/provider/finapi/payments/${paymentId}'
  static findOpenBankingPaymentMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetInstitutions
   * @request GET:/api/v1/open-banking/institutions
   */
  getInstitutions = (query: GetInstitutionsParams, params: RequestParams = {}) =>
    this.http.request<InstitutionDto[], any>({
      path: `/v1/open-banking/institutions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getInstitutionsPath = '/v1/open-banking/institutions'
  static getInstitutionsMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetAccountConnections
   * @request GET:/api/v1/open-banking/connections
   */
  getAccountConnections = (query: GetAccountConnectionsParams, params: RequestParams = {}) =>
    this.http.request<AccountConnectionDto[], any>({
      path: `/v1/open-banking/connections`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAccountConnectionsPath = '/v1/open-banking/connections'
  static getAccountConnectionsMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name DeleteAccount
   * @request DELETE:/api/v1/open-banking/providers/{providerType}/bank-accounts/{id}
   */
  deleteAccount = (providerType: string, id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/providers/${providerType}/bank-accounts/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteAccountPath = '/v1/open-banking/providers/${providerType}/bank-accounts/${id}'
  static deleteAccountMethod = 'DELETE'
}
